'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SortDown = exports.SortUp = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _fp = require('lodash/fp');

var _arrow = require('./arrow');

var _arrow2 = _interopRequireDefault(_arrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SortUp = exports.SortUp = function SortUp() {
    return _react2.default.createElement(
        'span',
        { className: 'sort-icon sort-asc' },
        _react2.default.createElement(_arrow2.default, null)
    );
};

var SortDown = exports.SortDown = function SortDown() {
    return _react2.default.createElement(
        'span',
        { className: 'sort-icon sort-desc' },
        _react2.default.createElement(_arrow2.default, null)
    );
};

var sortArrows = function sortArrows(direction) {
    return _react2.default.createElement(
        'span',
        { className: 'sort-arrows sort-' + (0, _fp.toLower)(direction) },
        _react2.default.createElement(SortUp, null),
        _react2.default.createElement(SortDown, null)
    );
};

exports.default = sortArrows;